import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { APIDataTables, DataTables } from "../../../Constant";
import AddRows from "./AddRows";
import ChildRows from "./ChildRows";
import RowSelectionAndDeletion from "./RowSelectionAndDeletion";
import CustomFiltering from "./CustomFiltering";

const ApiDataTablesContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={APIDataTables} parent={DataTables} title={APIDataTables} />
      <Container fluid>
        <Row>
          <AddRows />
          <ChildRows/>
          <RowSelectionAndDeletion/>
          <CustomFiltering/>
        </Row>
      </Container>
    </>
  );
};

export default ApiDataTablesContainer;
